import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

function parseHttpsUrl(value: string): URL | undefined {
  try {
    const url = new URL(value);
    return url.protocol === "https:" ? url : undefined;
  } catch {
    return undefined;
  }
}

export const astroBaseUrl = z
  .string()
  .trim()
  .transform((value, ctx) => {
    const url = parseHttpsUrl(value);
    if (!url) {
      ctx.addIssue({
        code: "custom",
        message:
          "Astro API URL must be a full https URL, for example https://example.com/api/v2",
      });
      return z.NEVER;
    }
    return `${url.origin}${url.pathname.replace(/\/+$/, "")}`;
  });

const relationId = z
  .string()
  .trim()
  .nullish()
  .transform((value) => value ?? undefined);

export const astroSettings = defineIntegrationSettings({
  fields: {
    baseUrl: astroBaseUrl,
    senderRelationId: relationId,
    orderingPartyRelationId: relationId,
    createReturnsEnabled: z.boolean(),
    processReturnsEnabled: z.boolean(),
  },
  secrets: { apiToken: z.string().trim().min(1, "API token is required") },
  computed: {},
});
